import { render, staticRenderFns } from "./ekko.influencer-card.vue?vue&type=template&id=42a41742&scoped=true&"
import script from "./ekko.influencer-card.vue?vue&type=script&lang=ts&"
export * from "./ekko.influencer-card.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.influencer-card.vue?vue&type=style&index=0&id=42a41742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a41742",
  null
  
)

export default component.exports